import { Skill } from '../skills/skills.model';
import { UserSkill } from './user-skills.model';

export interface GenerateUserSkillOptions {
  readonly userId: number;
  readonly skills?: readonly number[];
}

export function userSkillsFromSkills(skills: readonly Skill[]) {
  return { skills: skills.map(skill => skill.id) };
}

export function generateUserSkillObject({
  userId,
  skills = [],
}: GenerateUserSkillOptions): UserSkill {
  return {
    id: userId,
    skills,
  };
}
